module.exports = __webpack_public_path__ + "static/Cover-5772c3eea4ccf1705160ca53d55d7f96.png";